export enum PaymentGateways {
    None = '0',
    TNS = '1',
    WPM = '2',
    TTS = '3',
    AXEPT = '4',
    AXEPT_TESTING = '5'
  }